import {
    CARD_TO_CARD_ACTION_TYPE_CARD_LINKED,
    CARD_TO_CARD_ACTION_TYPE_EGIFT_CREATED,
    CARD_TO_CARD_ACTION_TYPE_MERCHANT_CHANGED,
    CARD_TO_CARD_ACTION_TYPE_PAYPAL,
    CARD_TO_CARD_ACTION_TYPE_VENMO,
    CARD_TO_CARD_ACTION_TYPE_VISA_CARD_CREATED,
    CARD_TO_CARD_ACTION_TYPE_ZELLE,
    LINK_STATUS_FAILURE,
    LINK_STATUS_PENDING,
    LINK_STATUS_SUCCESS,
    MEDIUM_TYPE_CARD_TO_CARD,
    MEDIUM_TYPE_VIRTUAL,
} from '@/prisma/schemaConstants'
import { xhrApiClient } from '@/config/xhrApiClient'
import { API_GIFT_RECEIVED_DETAILS } from '@/config/xhrApiClientRouteNames'

export type TGiftQueryResult = {
    data: IGift
    message?: string
    error?: string
}

export interface IGift {
    card_uuid: string
    gift_token?: string
    denomination: number
    balance?: number
    medium_type: typeof MEDIUM_TYPE_VIRTUAL | typeof MEDIUM_TYPE_CARD_TO_CARD
    brand: string
    brand_slug: string
    sender_name: string
    gift_message?: string
    date_received: string
    date_fulfilled: string
    card_image: string
    wrapper_image?: string
    gift_id?: string
    card_link?: ICardLink
    redemption_method?:
        | typeof CARD_TO_CARD_ACTION_TYPE_CARD_LINKED
        | typeof CARD_TO_CARD_ACTION_TYPE_MERCHANT_CHANGED
        | typeof CARD_TO_CARD_ACTION_TYPE_EGIFT_CREATED
        | typeof CARD_TO_CARD_ACTION_TYPE_VISA_CARD_CREATED
        | typeof CARD_TO_CARD_ACTION_TYPE_VENMO
        | typeof CARD_TO_CARD_ACTION_TYPE_PAYPAL
        | typeof CARD_TO_CARD_ACTION_TYPE_ZELLE
        | null
    event_log?: Array<IGiftEvent>
    redemption_options?: IRedemptionOptions
    plastic_exchange_eligible?: boolean
    plastic_exchange?: {
        plastic_card_id: string
        creation_date: Date | string
        city: string
        state: string
    }
    is_pg_plus: boolean
    created_at?: Date
    is_24_hours_old?: boolean
}

export interface ICardLink {
    gyp_gift_id: string
    last_four: string
    card_network: string
    link_status:
        | typeof LINK_STATUS_PENDING
        | typeof LINK_STATUS_FAILURE
        | typeof LINK_STATUS_SUCCESS
        | undefined
    brand_name: string
}

export interface IRedemptionOptions {
    redeemable_via_egift: boolean
    redeemable_via_plastic: boolean
    redeemable_via_card_link: boolean
    brand_change_allowed: boolean
}

export interface IGiftEvent {
    date: string
    time: string
    description: string
    created_at: Date
}

const fetchGiftReceivedDetails = async (uuid: string): Promise<any> => {
    const response = await xhrApiClient.get(`${API_GIFT_RECEIVED_DETAILS}`, {
        params: { card_uuid: uuid },
    })

    response.data = {
        ...response.data,
        data: {
            ...response.data.data,
            redemption_options: {
                ...response.data.data.redemption_options,
                redeemable_via_card_link: false,
                redeemable_via_plastic: false
            }
        }
    }
    return response.data
}

export default fetchGiftReceivedDetails
